import type { ShiftMeal } from '@libs/data-access/queries'
import { Text } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import type { FC } from 'react'

import styles from './MealCol.module.css'
import { MealRow, type ScheduleType } from './MealRow/MealRow'

type Props = {
  meals: ShiftMeal[]
  scheduleType: ScheduleType
}

export const hasMealsToShow = (
  meals: ShiftMeal[],
  scheduleType: ScheduleType
) => {
  if (scheduleType === 'clocked') {
    return (
      meals.filter(meal => meal.clocked_meal_taken_status !== null).length > 0
    )
  }
  if (scheduleType === 'planned') {
    return meals.filter(meal => meal.planned_meal_type !== null).length > 0
  }
  return meals.length > 0
}

export const MealCol: FC<Props> = ({ meals, scheduleType }) => {
  const { t } = usePlanningFormTranslation()

  return (
    <div className={styles.Row}>
      <Text as='span' size='m' className={styles.Title}>
        {t('shiftRealHoursForm.mealCol.title')}
      </Text>
      <span className={styles.Col}>
        {meals.map(meal => {
          if (meal) {
            return (
              <MealRow meal={meal} key={meal.id} scheduleType={scheduleType} />
            )
          }
          return undefined
        })}
      </span>
    </div>
  )
}
